var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.imgurl)?_c('img',{directives:[{name:"stat",rawName:"v-stat.brow",value:({
    tag: 'theme_mall.ad_brow',
    ext: {
      fthemeid: _vm.data.id,
      fadid: _vm.data.dpId,
    },
  }),expression:"{\n    tag: 'theme_mall.ad_brow',\n    ext: {\n      fthemeid: data.id,\n      fadid: data.dpId,\n    },\n  }",modifiers:{"brow":true}}],staticClass:"wecoupon-mall-adcard",attrs:{"src":_vm.imgurl,"alt":"ad image"},on:{"click":_vm.handleClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }